<template>
  <keep-alive :include="cachedViews">
    <router-view />
  </keep-alive>
</template>
<script>
export default {
  name: "PageView",
  data() {
    return {
      cachedViews: ["Solutions", "News"],
    };
  },
};
</script>
<style scoped>
</style>




// WEBPACK FOOTER //
// src/view/PageView.vue